import React from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import { Routes } from "./Routes/Routes";
import "aos/dist/aos.css";
import "./styles/brand.css";
import "./Components/landing.css";

var rootEl = document.getElementById("root");
var app = (
  <HelmetProvider>
    <Routes />
  </HelmetProvider>
);

// react-snap pre-renders pages; use hydrate() for those, render() for live SPA.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrate(app, rootEl);
} else {
  ReactDOM.render(app, rootEl);
}
